export class HeicCertModel {

  jobUid: number;
  clientUid: number;
  bandOneAndTwo: string;
  presenceOfIsolationSwitching: string;
  supplyIntakeCond: string;
  presenceEarthConductor: string;
  adaquacyOfAccess: string;
  presenceOfCpc: string;
  presenceOfDiagrams: string;
  singlePoleDevices: string;
  sElvPelvFelv: string;
  presenceBondingConstructor: string;
  idOfConductors: string;
  measuresExternalInfluence: string;
  doubleInsualtion: string;
  choiceSettingProtDevices: string;
  surgePresentAndOk: string;
  electSeperation: string;
  selectionOfConductors: string;
  insualtionOfLiveParts: string;
  presenceOfRcds: string;
  installtionMethods: string;
  barriersEnclosure: string;
  protectedAgainstMechDamage: string;
  placingOutOfReach: string;
  proxToNonElectricalServices: string;
  connectionOfConductors: string;
  rcdFunctionalTestOk: string;
  jobCertConfigUid: number;
  
  insResistCont: string;
  eliEarthElec: string;
  rcd: string;
  other: string;
  intervalYears: string;
  remarks: string;
  departures: string;

  overallSummary: string;
  disconnectionTime: string;

  constructor() {

  }
}